import { render, staticRenderFns } from "./StockAmount.vue?vue&type=template&id=f3f00794&"
import script from "./StockAmount.vue?vue&type=script&lang=js&"
export * from "./StockAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports